import "./Valeurs.css";

export default function Values() {
  const values = [
    {
      title: "Respect des délais et de la confidentialité",
      desc: "Nous garantissons des interventions ponctuelles et un sérieux irréprochable.",
      color: "#ff007a" // couleur du fond derrière
    },
    {
      title: "Produits écologiques et biodégradables",
      desc: "Nous utilisons des solutions respectueuses de l’environnement.",
      color: "#007bff"
    },
    {
      title: "Équipe sérieuse, formée et disponible",
      desc: "Une équipe professionnelle prête à intervenir rapidement.",
      color: "#ff9900"
    },
    {
      title: "Intervention rapide à Marseille et alentours",
      desc: "Nous couvrons toute la région avec efficacité.",
      color: "#32cd32"
    }
  ];

  return (
    <section className="values container">
      <h2 className="section-title">
        Nos <span className="yellow">valeurs</span>
      </h2>

      <div className="values-grid">
        {values.map((v, i) => (
          <div className="value-card-container" key={i}>
            <div className="value-card-bg" style={{ backgroundColor: v.color }}></div>

            <div className="value-card">
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}